import React from 'react';
import AgentCell from './components/AgentCell';
import ToolCell from './components/ToolCell';
import StatusCell from './components/StatusCell';
import SelectedCell from './components/SelectedCell';
import WorkspaceCell from './components/WorkspacesCell';
import DateFormatter from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/Date';

/**
 * Agents executions (run status log) table.
 * ctx: `{ show, agentType, isFetching }`
 */
const runStatusLogSchema = {
  id: 'runStatusLog',
  loading: { mockRows: 13, skeleton: ({ isFetching }) => isFetching },
  columns: [
    {
      header: (_, { show }) => <SelectedCell isHeader disabled={ show } />,
      id: 'selected',
      accessor: 'selected',
      visible: true,
      sortable: false,
      resizable: false,
      maxWidth: 55,
      minWidth: 55,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: (rowInfo, { show }) => <SelectedCell rowInfo={ rowInfo } disabled={ show } />
    },
    {
      header: (_, { agentType }) => (agentType === 'agent_executions' ? 'Runner' : 'Security Scanner'),
      accessor: 'agent_name',
      id: 'agent_name',
      maxWidth: 147,
      minWidth: 147,
      visible: true,
      sortable: false,
      cell: (rowInfo) => <AgentCell rowInfo={ rowInfo } />
    },
    {
      header: 'Tool',
      accessor: 'tool',
      id: 'tool',
      visible: true,
      sortable: false,
      maxWidth: 104,
      minWidth: 104,
      cell: ({ value }) => <ToolCell value={ value } />
    },
    {
      header: 'Start',
      accessor: 'create_date',
      id: 'create_date',
      visible: true,
      sortable: true,
      maxWidth: 200,
      minWidth: 200,
      cell: ({ value }) => <DateFormatter date={ value } />
    },
    {
      header: 'Status',
      accessor: 'status',
      id: 'status',
      visible: true,
      sortable: false,
      maxWidth: 102,
      minWidth: 102,
      cell: (rowInfo) => <StatusCell rowInfo={ rowInfo } />
    },
    {
      header: 'Category',
      accessor: 'category',
      id: 'category',
      visible: true,
      sortable: false,
      maxWidth: 270,
      minWidth: 270,
      cell: ({ value }) => <div style={ { color: '#90a9c0', fontSize: '14.5px', cursor: 'pointer' } } title={ value }>{value}</div>
    },
    {
      header: 'End',
      accessor: 'update_date',
      id: 'update_date',
      visible: true,
      sortable: false,
      maxWidth: 115,
      minWidth: 115,
      cell: ({ value }) => <DateFormatter date={ value } />
    },
    {
      header: 'Triggered By',
      accessor: 'triggered_by',
      id: 'triggered_by',
      visible: true,
      sortable: true,
      maxWidth: 109,
      minWidth: 109,
      cell: ({ value }) => <div style={ { color: '#90a9c0', fontSize: '14.5px', cursor: 'pointer' } } title={ value }>{value}</div>
    },
    {
      header: 'Workspaces',
      accessor: 'parameters_data.workspaces_commands',
      id: 'workspaces',
      visible: true,
      sortable: false,
      cell: ({ value }) => <WorkspaceCell data={ value } />
    }
  ]
};

export default runStatusLogSchema;
